import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

export const getPoizonClients = reatomAsync(() => {
  return API.poizonClientApi.clientControllerGetClients().then((d) => d.data);
}, "getPoizonClients").pipe(withDataAtom(null), withIsLoadingAtom());
